import React, { useEffect, useState } from "react";
import Layout from "../../common/Layout";
import PropTypes from "prop-types";
import AddItemButton from "../../common/components/base/AddItemButton";
import ItemsGrid from "../../common/components/widgets/ItemsGrid";
import Swal from "sweetalert2";
import LoadingSpinner from "../../common/components/LoadingSpinner/LoadingSpinner";
// import { useMutation, useQuery } from "@apollo/client"; // TODO: Replaced with REST hooks
// import { client } from "../../settings/apollo"; // TODO: Replaced with REST hooks
// import { getBannerDefinitions, GET_BANNERS_DEFINITIONS } from "./graphql/queries"; // TODO: Replaced with REST hooks
// import { DELETE_BANNER } from "./graphql/mutations"; // TODO: Replaced with REST hooks
import { useSkills } from "../../hooks/useSkills";
import { useDeleteSkills } from "../../hooks/useDeleteSkills";
import { useUpdateSkills } from "../../hooks/useUpdateSkills";
import { useCreateSkills } from "../../hooks/useCreateSkills";
import AdminSettingsNavigation from "../adminSettings/AdminSettingsNavigation";
import Select from "react-select";
import CenteredPopover from "../Skills/SkillsPopover";
import { RolesTypes } from '../../constants/roles';
import useAppStore from "../../store/appStore";

const columns = ["name", "type", "action"];
const columnsName = ["name", "type", "action"];

const SkillsList = (props) => {
  SkillsList.propTypes = {
    page: PropTypes.number,
    name: PropTypes.string,
  };
  const user = useAppStore((state) => state.user);
  const [skills, setSkills] = useState([]);
  const [openPopover, setOpenPopover] = useState(false);
  const [isUpdate, setIsUpdate] = useState(false);
  const [selectedSkills, setSelectedSkills] = useState({
    _id: "",
    name: "",
    type: "",
  });
    const [selectedSkillType, setSelectedSkillType] = useState({
    value: "",
    label: "All",
  });
      const [selectedSkillTypePopOver, setSelectedSkillTypePopOver] = useState({
    value: "hardSkill",
    label: "Hard Skill",
  });
  const deleteSkillsMutation = useDeleteSkills();
  const { data, isFetching: loading, error } = useSkills(selectedSkillType.value);
  const createSkillsMutation = useCreateSkills();
  const updateSkillsMutation = useUpdateSkills();

  useEffect(() => {
    if (data?.skills) {
      setSkills(data.skills);
    }
  }, [data]);

  const remove = (item) => {
    Swal.fire({
      title: "Are you sure you want to delete this Skill?",
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: "Yes",
      denyButtonText: "No",
      customClass: {
        actions: "my-actions",
        cancelButton: "order-1 right-gap",
        confirmButton: "order-2",
        denyButton: "order-3",
      },
    }).then((result) => {
      if (result.value === true) {
        deleteSkillsMutation.mutate({ id: item._id }, {
          onSuccess: (data) => {
            if (data.success) {
              Swal.fire({
                type: "success",
                title: "Skill deleted!",
                showConfirmButton: false,
                timer: 1500,
              });
              // Data will be automatically refetched due to query invalidation in the hook
            }
          },
          onError: (error) => {
            Swal.fire({
              type: "error",
              title: "Error deleting skill",
              showConfirmButton: false,
              timer: 1500,
            });
            console.log(error);
          },
        });
      }
    });
  };

  const edit = (item) => {
    setSelectedSkills(item);
    setSelectedSkillTypePopOver({ value: item.type, label: item.type === "hardSkill" ? "Hard Skills" : item.type === "metaSkill" ? "Meta Skills" : "All Skills" });
    setIsUpdate(true);
    setOpenPopover(true);
  };

  const create = () => {
    setSelectedSkills({
      _id: "",
      name: "",
      type: "",
    }); 
    setSelectedSkillTypePopOver({ value: "hardSkill", label: "Hard Skill" });
    setIsUpdate(false);
    setOpenPopover(true);
  };

  const handleConfirm = ({ selectedOption, inputValue }) => {
    console.log("Handle Confirm called with:", { selectedOption, inputValue });
    if (isUpdate) {
      updateSkillsMutation.mutate(
        { id: selectedSkills._id, 
         input: { type: selectedOption.value, name: inputValue } }, 
        {
          onSuccess: () => {
            Swal.fire({
              icon: "success",
              title: "Skill updated successfully!",
              showConfirmButton: false,
              timer: 1500,
            });
            setOpenPopover(false);
          },
          onError: (error) => {
            Swal.fire({
              icon: "error",
              title: "Error updating skill",
              text: error.message,
              showConfirmButton: true,
            });
          },
        }
      );
    } else {
      createSkillsMutation.mutate(
        {  input: { type: selectedOption.value, name: inputValue } },
        {
          onSuccess: () => {
            Swal.fire({
              icon: "success",
              title: "Skill created successfully!",
              showConfirmButton: false,
              timer: 1500,
            });
            setOpenPopover(false);
          },
          onError: (error) => {
            Swal.fire({
              icon: "error",
              title: "Error creating skill",
              text: error.message,
              showConfirmButton: true,
            });
          },
        }
      );
    }
  };

  return (
    <Layout name="Skills List">
      <div className="wizard-container">
        <AddItemButton OnClick={() => create()} disabled={openPopover} />
        <AdminSettingsNavigation path={props.match.path} />
        <div className="row">
          <div className="col-sm-12 col-md-10" />
          <div className="col-sm-12 col-md-2">
            <Select
              value={selectedSkillType}
              onChange={(values) =>
                values != null
                  ? setSelectedSkillType(values)
                  : setSelectedSkillType({ type: "", label: "All" })
              }
              options={[
                { value: "hardSkill", label: "Hard SKills" },
                { value: "metaSkill", label: "Meta Skills" },
                { value: "", label: "All Skills" },
              ]}
            />
          </div>
        </div>
        {loading && <LoadingSpinner />}
        {error && <div>`Error! ${error.message}`</div>}
        {!skills && <div>No Skills available</div>}
        {skills && !loading && (
          <div>
            <ItemsGrid
              columns={columns}
              columnsName={columnsName}
              remove={user.me.userRole === RolesTypes.SUPERUSER ? (index, value) => remove(value) : undefined}
              edit={(index, value) => edit(value)}
              title={"Skills"}
              rowsPerPage={10}
              items={skills}
              pagination={true}
            />
          </div>
        )}
      </div>
      <CenteredPopover
        open={openPopover}
        onClose={() => setOpenPopover(false)}
        title={isUpdate ? "Update Skill" : "Insert New Skill"}
        description={isUpdate ? "Modify the type of skill and enter the new name" : "Select the type of skill and enter the name"}
        nameText="Skill Name"
        selectOptions={ user.me.userRole === RolesTypes.SUPERUSER ? [
          { value: "hardSkill", label: "Hard Skills" },
          { value: "metaSkill", label: "Meta Skills" },
        ] : [{ value: "hardSkill", label: "Hard Skills" }]}
        defaultSelectValue={selectedSkillTypePopOver}
        defaultInputValue={isUpdate ? selectedSkills.name : ""}
        onConfirm={handleConfirm}
      />
    </Layout>
  );
};

export default SkillsList;
